/**
 * User Location Styles
 *
 * Blue dot and accuracy circle styles for user geolocation display.
 */

import type { LayerSpecification } from "maplibre-gl";

/**
 * User location "Blue Dot" style
 */
export const USER_LOCATION_STYLE: LayerSpecification = {
  id: "user-location",
  type: "circle",
  source: "user-location",
  paint: {
    "circle-color": "#4285f4",
    "circle-radius": 8,
    "circle-stroke-color": "#ffffff",
    "circle-stroke-width": 3,
  },
};

/**
 * User location accuracy circle
 */
export const USER_LOCATION_ACCURACY_STYLE: LayerSpecification = {
  id: "user-location-accuracy",
  type: "circle",
  source: "user-location",
  paint: {
    "circle-color": "rgba(66, 133, 244, 0.15)",
    "circle-radius": ["get", "accuracyRadius"],
    "circle-stroke-color": "rgba(66, 133, 244, 0.3)",
    "circle-stroke-width": 1,
  },
};
